import React from 'react';

import {
  Stack,
} from '@mui/material';

import { Class } from '../../../services/classes/types';
import { Metadata } from '../../../services/types';

import ClassSettingsCard from './ClassSettingsCard';
import CourseCard from './CourseCard';
import NotificationsCard from './NotificationsCard';

interface SettingsTabProps {
  classObj: Class,
  metadata?: Metadata,
}

const SettingsTab = ({
  classObj,
  metadata,
}: SettingsTabProps) => (
  <Stack direction="column" spacing={2}>
    <CourseCard classObj={classObj} classObjMetadata={metadata} />
    <NotificationsCard classObj={classObj} />
    <ClassSettingsCard classObj={classObj} />
  </Stack>
);
export default SettingsTab;
